import {useCallback} from 'react';
import {useParams} from 'react-router-dom';

export const useActiveCasusId = (): string | undefined => {
  const {activeCasusId} = useParams();
  return activeCasusId ?? undefined;
};

export const useActiveCasusIdOrThrow = (): {
  getActiveCasusIdOrThrow: () => string;
  getActiveCasusIdOrUndefined: () => string | undefined;
} => {
  const activeCasusId = useActiveCasusId();

  const getActiveCasusIdOrUndefined = useCallback(
    () => activeCasusId,
    [activeCasusId]
  );

  const getActiveCasusIdOrThrow = useCallback(() => {
    if (!activeCasusId) {
      throw Error('no casus context given!');
    }
    return activeCasusId;
  }, [activeCasusId]);

  return {
    getActiveCasusIdOrThrow,
    getActiveCasusIdOrUndefined,
  };
};
